export default __webpack_public_path__ + "media/maps/new-map-icon-21bf53d8.svg";